// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x4db","col":"styles_col__QaNw0"};